import { E_Custom_Dispatch_Event, E_Type_Of_Event, customEventListener } from "helpers/Events";
import { ChargeConstant } from "presentation/constant/ChargeHeader/ChargeConstant";
import { useChargeHeaderMaintenanceVM } from "presentation/hook/ChargeHeaderMaintenance/useChargeHeaderMaintenanceVM";
import { useChargeHeaderMaintenanceTracked } from "presentation/store/ChargeHeaderMaintenance/ChargeHeaderMaintenanceProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { useCallback, useEffect, useState } from "react";
import { IconButton } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

export const ChargeHeaderMaintenanceHeader: React.FC = () => {
    //const messageBarVM = useMessageBarVM();
    const [, setIsEditCriteria] = useState(false);
    const headerCons = ChargeConstant.ChargeHeader;
    const chargeHeaderMaintenanceVM = useChargeHeaderMaintenanceVM();
    const [chargeHeaderState] = useChargeHeaderMaintenanceTracked();

    //const selectedRows = chargeHeaderState.selectedChargeHeaderRows;

    const handleSearchClick = useCallback(() => {
        chargeHeaderMaintenanceVM.onSearchClick();
    }, [chargeHeaderMaintenanceVM]);

    const onChargeHeaderSearchChange = (e: any) => {
        switch (e.detail.action) {
            case E_Custom_Dispatch_Event.CHARGE_HEADER_EDIT_CRITERIA_BACK:
                setIsEditCriteria(e.detail.data.isEdit);
                break;
            case E_Custom_Dispatch_Event.CHARGE_HEADER_HIDE_RIGHT_PANEL:
                setIsEditCriteria(true);
                break;
            case E_Custom_Dispatch_Event.CHARGE_HEADER_PREFERENCE_GET:
                // setChargeHeaderMaintenanceModel(e.detail.data.ChargeHeaderMaintenanceModel);
                break;
            case E_Custom_Dispatch_Event.CHARGE_HEADER_PREFERENCE_CURRENT_UPDATE:
                // setChargeHeaderMaintenanceModel(prev => ({ ...prev, currentSearchPreference: e.detail.data.currentSearchPreference }));
                break;
            // case E_Custom_Dispatch_Event.CONTAINER_DETAIL_SHOW:
            //     setTitle('CONTAINER DETAILS');
            //     setIsList(false);
            //     break;
            // case E_Custom_Dispatch_Event.CONTAINER_DETAIL_HIDE:
            //     setTitle('CONTAINER SEARCH');
            //     setIsList(true);
            //     break;
        }
    }

    useEffect(() => {
        customEventListener(E_Type_Of_Event.CHARGE_HEADER_SEARCH_EVENT, onChargeHeaderSearchChange);
    }, []);


    /*const handleRefreshStateClick = useCallback(() => {
        if (_.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select a record!');
        } else {
            chargeHeaderMaintenanceVM.onRefreshHeaderState(selectedRows).then(() => {
                messageBarVM.showSuccess('Refresh successfully.');
                chargeHeaderMaintenanceVM.onSearch(chargeHeaderState.searchCriteria, EMPTY_SEARCH_MODE_ENTITY)
            }).catch((error) => {
                messageBarVM.showError('Refresh failure.');
            });
        }
    }, [chargeHeaderMaintenanceVM, chargeHeaderState.searchCriteria, selectedRows, messageBarVM]);*/




    return <>
        <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
            {/* <Breadcrumb> */}
            <HeaderTitle>{headerCons.CHARGE_PROCESSING}</HeaderTitle>
            {/* </Breadcrumb> */}
            {/* <Breadcrumb>
            <HPHBreadcrumb breadcrumbData={[{ title: headerCons.CHARGE_PROCESSING }]}  onCurrentClick={handleClose}/>
        </Breadcrumb> */}
            <StyledAction className="tm-animated-wrapper">
                <IconButton fileName='Icon-search' disabled={false} size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={handleSearchClick} />
            </StyledAction>
            {chargeHeaderState.forceRefresh && <></>}
        </Sidebarheader>
    </>
}